<template>
    <div>
        <h2 class="m-0 h1 text-uppercase">
            {{ $t('perfil.listado_entradas', { entradas: manager.termino_entradas }) }}
            <InfoToolTip :info="$t('perfil.info_cambiar_datos', { entrada: manager.termino_entrada })" />
        </h2>
        <div class="subtitle h3 light mb-4" data-cy="texto-identificativo-cambiar-datos">
            {{ $t('perfil.seleccionar_entradas', { entradas: manager.termino_entradas }) }}
            <h5 class="bold mt-1">{{ $t('perfil.coste_cambio', { entrada: manager.termino_entrada, coste_cambio_nombre: $n(coste_cambio_nombre, "currency") }) }}</h5>
        </div>
        <div style="overflow-y: auto; max-height: 600px;">
            <b-table
                striped 
                hover 
                responsive
                :items="pedido.entradas"
                :fields="fields"
                primary-key="id"
                class="shadow-sm"
            >
                <template #cell(seleccion)="data">
                    <b-form-checkbox
                        :value="data.item"
                        :data-cy="'check-entrada-' + data.index"
                        v-model="entradasSeleccionadas"
                    />
                </template>
    
                <template #cell(qr_code)="data">
                    <span class="text-primary font-weight-bold">{{ data.value }}</span>
                </template>
                
                <template #cell(asiento_info)="{ item }">
                    <div v-if="item.asiento">
                        <div><b>{{ $t('perfil.zona') }}:</b> {{ item.asiento.zona }}</div>
                        <div><b>{{ $t('perfil.fila') }}:</b> {{ item.asiento.fila }}</div>
                        <div><b>{{ $t('perfil.asiento') }}:</b> {{ item.asiento.asiento }}</div>
                    </div>
                    <div v-else>
                        <b-badge variant="secondary" class="p-2">{{ $t('perfil.sin_numerar') }}</b-badge>
                    </div>
                </template>
            </b-table>
        </div>

        <div v-if="entradasSeleccionadas.length > 0" class="mt-4 rounded d-flex flex-column flex-md-row justify-content-between align-items-md-center">
            <div class="mb-3 mb-md-0 mr-md-4">
                <h4 class="mb-2">{{ $t('perfil.entradas_seleccionadas', { entradas: manager.termino_entradas }) }}:</h4>
                <div class="d-flex flex-wrap">
                    <template v-for="(entrada, index) in entradasSeleccionadas">
                        <div 
                            :key="entrada.id" 
                            class="mr-2 mb-2 px-3 py-1 bg-white border rounded" 
                            :class="{ 'w-100': esMovil }"
                        >
                            <b>{{ index + 1 }}. {{ $t('perfil.qr') }}: </b> <span class="text-success">{{ entrada.qr_code }}</span>
                        </div>
                    </template>
                </div>
            </div>
            
            <div class="d-flex justify-content-end">
                <button 
                    @click="continuar" 
                    name="button" 
                    :class="!esMovil ? 'button effect-button large-button' : 'button effect-button w-100'" 
                    data-cy="cambiar-datos-paso-uno" 
                    id="cambiar-datos-paso-uno"
                >
                    <span>{{ $t('formularios.continuar') }}</span>
                </button>
            </div>
        </div>
        <div v-else class="mt-3 p-3 bg-light rounded text-center">
            <p class="mb-0 text-muted">{{ $t('perfil.debe_seleccionar_entradas', { entrada: manager.termino_entrada }) }}</p>
        </div>
    </div>
</template>

<script>
    import InfoToolTip from '@/components/common/InfoToolTip';

    export default {
        props: {
            pedido: {
                type: Object,
                required: true
            },
            esMovil: {
                type: Boolean,
                required: false,
                default: false
            },
            entradas: {
                type: Array,
                required: false,
                default: () => []
            },
            coste_cambio_nombre: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                entradasSeleccionadas: [ ...this.entradas ]
            };
        },
        methods: {
            continuar() {
                this.$emit('terminado', this.entradasSeleccionadas);
            }
        },
        computed: {
            fields() {
                return [
                    { key: 'seleccion', label: '', class: 'text-center', thStyle: { width: '5%' } },
                    { key: 'qr_code', label: this.$t('perfil.qr') },
                    { key: 'user_nombre', label: this.$t('perfil.nombre') },
                    { key: 'user_apellidos', label: this.$t('perfil.apellidos') },
                    { key: 'user_dni', label: this.$t('perfil.dni') },
                    { key: 'asiento_info', label: this.$t('perfil.ubicacion') }
                ];
            },
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        components: {
            InfoToolTip
        }
    };
</script>